module.exports = __webpack_public_path__ + "static/media/logo-node.994d64c0.svg";